export function CssUd() {
    const courses = [
        { title: "CSS + HTML 101 Crash Course", link: "https://www.udemy.com/course/html-5-css-3-web-development-project/?couponCode=24T2MT111524" },
        { title: "HTML and CSS for Beginners - Build a Website & Launch ONLINE", link: "https://www.udemy.com/course/modern-web-design-html5-css3-beginners-guide-to-websites/?couponCode=24T2MT111524" },
        { title: "Crash Course: Fundamentals Of HTML & CSS From Scratch", link: "https://www.udemy.com/course/beginner-crash-course-fundamentals-of-html-css-in-60-mins/?couponCode=24T2MT111524" },
        { title: "1 Hour CSS", link: "https://www.udemy.com/course/1-hour-css/?couponCode=24T2MT111524" },
        { title: "CSS Complete Course For Beginners", link: "https://www.udemy.com/course/css-complete-course-for-beginners/?couponCode=24T2MT111524" }
    ];

    return (
        <>
            <h1 className="html_ud_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 5</strong> recommended Udemy links that you can refer with certifications
            </h1>

            <h4 className="des_ud_html">
                1. Dive Into The Main Concepts <br />
                2. Animation Explanations with real world Examples <br />
                3. Important with Note Clarification.
            </h4>

            {/* Render courses dynamically */}
            {courses.map((course, index) => (
                <div className="container_html_ud_links" key={index}>
                    <p className="vid">
                        {index + 1}. {course.title}
                        <button
                            style={{
                                marginLeft: '200px',
                                padding: '7px',
                                background: 'black',
                                color: 'white',
                                borderRadius: '8px'
                            }}
                            onClick={() => window.open(course.link, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default CssUd;
